import styled from 'styled-components';  
import HrImg from '../../img/hr-maru.png';
import Img2 from '../../../img/vol3b.jpg';
import Img1 from '../../../img/vol3a.jpg';
const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`

const Vol3: React.VFC = () => {
  return (
    <Main>
            <div className="text-break Blog-comment">
                <p>今回は年中さんのレッスンを紹介します。
                </p>
                <p>先日行ったレッスンのテーマは『でんきのちから』。</p>
                <p>私たちの生活に不可欠な電気がどこからやってきてどのように役立っているのかを学習しました。</p>
                <p>その後、「こんな電化製品があったらいいな」という未来の電化製品を制作してもらいました。</p>
                <p>講師たちは、「家事ロボットが欲しいよね～」「買い物に行ってくれて、買ってきた食材で料理までしてくれたら最高！」「洗濯物もたたんでもらえたらなぁ...」と話して盛り上がっていました。</p>
                <p>そんな中、年中さんの女の子がつくってくれたものはコチラ！</p>
                <div className="card-mokuji">
                    <img width="335" height="251" src={Img1} alt="" />
                </div>
                <div className="card-mokuji mt-5">
                    <img width="335" height="251" src={Img2} alt="" />
                </div>
                <p>元気のない人にお花を配ってあげるロボットだそうです(*^^*)。</p>
                <p>自分がいかに楽するかを考えていた私たち、恥ずかしい気持ちになりつつ、心が洗われたようでした。</p>
            </div>
    </Main>
    
  );
}
export default Vol3;